import styled from 'styled-components'
import { hideAtMobile, Media } from '@raysync/common/theme'
import InviteBg from '../images/invite.png'
import InviteMobileBg from '../images/invite_m.png'
export const PostWrapper = styled.div`
  background: #f6f7f8;
`
export const PostContent = styled.div`
  max-width: 800px;
  border-radius: 10px;
  padding: 30px 40px;
  background-color: #fff;
  ${Media.phone`
    padding: .34rem .3rem;
    border-radius: .18rem;
  `}
`
export const PostTitle = styled.h1`
  border-radius: 10px;
  padding: 30px;
  background: #eff3ff;
  margin-bottom: 20px;
  font-size: 40px;
  line-height: 1.4;
  color: #252a3a;
  font-weight: bold !important;
  ${Media.phone`
    font-size: 30px;
    margin-bottom: .4rem;
    padding: .4rem;
    border-radius: .16rem;
  `}
`
export const PostDate = styled.span`
  display: block;
  font-size: 14px;
  line-height: 1.5;
  color: #7e8494;
  margin-bottom: 20px;
  ${Media.phone`
    font-size: .24rem;
    margin-bottom: .3rem;
  `}
`

export const PostShare = styled.div`
  display: flex;
  align-items: center;
  padding: 30px 0;
  width: 100%;
  justify-content: center;
  span {
    color: #252a3a;
  }
  a {
    display: inline-block;
    margin-right: 18px;
  }
  svg {
    width: 40px;
    height: 40px;
  }
  ${Media.phone`
    padding-top: .26rem;
    border-top-width: .01rem;
    svg {
      width: .6rem;
      height: .6rem;
    }
    a {
      margin-right: .16rem;
    }
  `}
`
export const HotNewsContainer = styled.div`
  padding: 80px 0;
  > div {
    justify-content: center;
  }
  ${Media.phone`
    padding: .8rem 0;
  `}
`
export const HotNewsTitle = styled.h4`
  font-size: 30px;
  text-align: center;
  ${Media.phone`
    font-size: .36rem;
  `}
`
export const PostContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
export const ContentTable = styled.div`
  width: 250px;
`

export const InviteBox = styled.div`
  position: sticky;
  top: 120px;
  right: 0px;
  width: 100%;
  height: 438px;
  background: url(${InviteBg}) no-repeat;
  background-size: 100% 100%;
  p {
    padding-top: 170px;
    font-size: 20px;
    line-height: 1.5;
    text-align: center;
    font-size: bold;
    span {
      font-weight: bold;
      color: ${p => p.theme.color.secondary};
    }
  }
  > div {
    padding: 0 20px;
    button {
      border-radius: 4px;
      margin-top: 20px;
      font-size: 14px;
      font-weight: 500;
      :hover {
        &:nth-child(1) {
          background: #e55c1f;
        }
        &:nth-child(2) {
          color: ${p => p.theme.color.secondary};
          background: #ffece4;
        }
      }
    }
  }
  ${Media.phone`
    position: unset;
    background-size: 100%  100%;
    margin-bottom: 1.2rem;
    height: 7.6rem;
    background-image: url(${InviteMobileBg});
    p {
      font-size: .4rem;
      padding-top: 3.16rem;
    }
    > div {
      padding: 0 .9rem;
      button {
        border-radius: .08rem !important;
        height: .84rem !important;
        line-height: .84rem !important;
      }
    }
  `}
`
export const HeaderItem = styled.li`
  font-size: 14px;
  line-height: 1.5;
  text-decoration: none !important;
  padding-left: ${p => (p.isSub ? '30px' : '0')};
  color: ${p => (p.actived ? p.theme.color.secondary : '#636772')};
  margin-top: ${p => (p.isSub ? '8px' : '16px')};
  cursor: pointer;
  :hover {
    color: ${p => p.theme.color.secondary};
  }
`
export const NavigationWrap = styled.div`
  width: 250px;
  position: relative;
  ${hideAtMobile};
`
export const NavigationBox = styled.div`
  width: 100%;
  position: sticky;
  top: 120px;
  left: 0px;
  p {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
    svg {
      margin-right: 14px;
    }
  }
  ul {
    max-height: 80vh;
    overflow-y: auto;
    list-style: none;
    padding-left: 0;
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 5px;
    }
    li {
    }
  }
`
